<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'permitusers'" [businessName]="vm.businessName"
    [permitNo]="vm.permitNo"></cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>

<div class="container" *ngIf="!vm.isOpening">
    <form>
        <br />
        <div class="row">
            <div class="col-sm-7 pb-1">
                <div class=" section-header col-md-6 ">Operator Accounts</div>
            </div>
            <div class="col-sm-2 pt-1 text-right">
                <button class="btn btn-inline btn-link btn-sm" (click)="addNew()">
                    Add New</button>
            </div>
            <div class=" col-sm-3">
                <input class="form-control" type="text" name="filterRefNo" placeholder="Search"
                    [(ngModel)]="vm.filter.search" (keyup)="onFilterChange($event)" (paste)="onPaste($event)">
            </div>
        </div>
        <table class="admins table table-striped table-sm">
            <thead>
                <tr>
                    <th class="row-ref" scope="col">
                        <div class="font-weight-bold  px-1 d-flex">
                            <div>Phone</div>
                            <div class="pl-2"> <a href="javascript:void()" (click)="onSort($event,'UserName')">
                                    <core-table-sorter [isSorted]="vm.filter.orderBy == 'UserName'"
                                        [isDescending]="vm.filter.isDesc"></core-table-sorter>
                                </a></div>
                        </div>
                    </th>
                    <th scope="col">
                        <div class="font-weight-bold  px-1 d-flex">
                            <div>Name</div>
                            <div class="pl-2"> <a href="javascript:void()" (click)="onSort($event,'Name')">
                                    <core-table-sorter [isSorted]="vm.filter.orderBy == 'Name'"
                                        [isDescending]="vm.filter.isDesc"></core-table-sorter>
                                </a></div>
                        </div>
                    </th>
                    <th scope="col">
                        <div class="font-weight-bold  px-1 d-flex">
                            <div>Email</div>
                            <div class="pl-2"> <a href="javascript:void()" (click)="onSort($event,'Email')">
                                    <core-table-sorter [isSorted]="vm.filter.orderBy == 'Email'"
                                        [isDescending]="vm.filter.isDesc"></core-table-sorter>
                                </a></div>
                        </div>
                    </th>
                    <th scope="col">
                        <div class="font-weight-bold  px-1 d-flex">
                            <div>Status</div>
                            <div class="pl-2"> <a href="javascript:void()" (click)="onSort($event,'Status')">
                                    <core-table-sorter [isSorted]="vm.filter.orderBy == 'Status'"
                                        [isDescending]="vm.filter.isDesc"></core-table-sorter>
                                </a></div>
                        </div>
                    </th>
                    <th class="row-ref" scope="col">
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr *ngIf="vm.items.length == 0">
                    <td colspan="5">No data found</td>
                </tr>
                <tr *ngFor="let c of vm.items">
                    <td class="username">{{c.userName}}</td>
                    <td class="name">{{c.fullName}}</td>
                    <td class="email">{{c.email}}</td>
                    <td class="status">{{c.status}}</td>
                    <td class="action text-right" ><a *ngIf="c.status=='Active'" href="javascript:void(0)" title="Send Installation"
                            (click)="sendInstallation(c.userId)"><i class="fas fa-sms"></i></a></td>
                    <td class="action text-right"><a href="javascript:void(0)" title="Edit" (click)="edit(c.userId)"><i
                                class="fas fa-edit"></i></a></td>

                </tr>
            </tbody>

        </table>

        <core-pager [take]="vm.filter.take" [skip]="vm.filter.skip" [totalCount]="vm.totalCount"
            (navigate)="onPage($event)"></core-pager>

    </form>
</div>

<cli-yes-cancel-modal #sendInstallationModal [id]="'sendInstallationModal'"></cli-yes-cancel-modal>